import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetBlocksQuery } from '../impl/blfApi/endpoints/blocks';

export const useGetBlocksByVariety = (
  customerId: string | undefined,
  varietyId: string | undefined,
  queryOptions?: {
    skip?: boolean;
  }
) => {
  const queryParams = useMemo(() => {
    if (!customerId || queryOptions?.skip) {
      return skipToken;
    }

    return { customer__id__in: [customerId ?? ''] };
  }, [customerId, queryOptions?.skip]);

  const {
    currentData: unfilteredBlocks,
    isFetching,
    isLoading,
  } = useGetBlocksQuery(queryParams, queryOptions);

  // get blocks that actually have the selected variety assigned
  const blocks = useMemo(() => {
    return unfilteredBlocks?.filter((block) => block.varietyID === varietyId);
  }, [unfilteredBlocks, varietyId]);

  return { blocks, isBlocksLoading: isLoading, isBlocksFetching: isFetching };
};
